export const ANALYTIC_USAGE_DROPDOWN = [
  { name: 'Digital Check-in', value: 'checkIn' },
  { name: 'In-room Dining', value: 'ird' },
  { name: 'Restaurant', value: 'restaurant' },
  { name: 'Spa', value: 'spa' },
  { name: 'Service Requests', value: 'hk' },
];

export const ANALYTIC_CHECK_IN_CHANNELS_DROPDOWN = [
  { name: 'All Channels', value: 'all' },
  { name: 'PWA', value: 'PWA' },
  { name: 'Mobile App', value: 'MOBILE_APP' },
  { name: 'Kiosk', value: 'KIOSK' },
  { name: 'Assisted Check-in', value: 'ASSISTED_CHECK_IN' },
];

export const ErrorGraphReportMessage = 'No errors present in the selected time period';

export const UTCGraphDisclaimerMessage = 'Data is based on UTC';

const roundToPrecision = (number, decimalPlaces) => {
  const multiplier = Math.pow(10, decimalPlaces || 0);
  return Math.round(number * multiplier) / multiplier;
};
